import type { FC } from 'react'
import { memo, useMemo } from 'react'
import { Navigate, useParams } from 'react-router'

import { PATH_SEGMENT } from 'routes/pathSegments'
import { generateRouter, PathUtils } from 'routes/routes.utils'

import { SupportContent } from 'features/Support/components/SupportContent/SupportContent'
import { SupportTicketDetails } from 'features/Support/components/SupportTicketDetails/SupportTicketDetails'

export const Support: FC = memo(() => {
  const { siteId } = useParams<{ siteId: string }>()
  const routesConfig = useMemo(
    () => ({
      [PATH_SEGMENT.ROOT]: <SupportContent />,
      [`${PATH_SEGMENT.TICKET_DETAILS}/:ticketId`]: <SupportTicketDetails />,
      [PATH_SEGMENT.OTHER]: <Navigate to={PathUtils.getHome(siteId)} replace />,
    }),
    [],
  )

  return <>{generateRouter(routesConfig)}</>
})
